import { recipeImportResponseSchema, type RecipeImportResponse } from '@awwyeah/shared';

export class RecipeImportError extends Error {}

/**
 * Calls `POST /api/recipes/import` (server-side fetch + schema.org parse). The server
 * never writes recipe state — this returns plain parsed data for the caller to hand to the
 * manual editor or write to Yjs directly (ROADMAP §1.3).
 */
export async function importRecipeFromUrl(url: string): Promise<RecipeImportResponse> {
  let response: Response;
  try {
    response = await fetch('/api/recipes/import', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ url }),
    });
  } catch {
    throw new RecipeImportError('network_error');
  }

  const body: unknown = await response.json().catch(() => null);
  const parsed = recipeImportResponseSchema.safeParse(body);
  if (!parsed.success) {
    throw new RecipeImportError('unexpected_response');
  }
  return parsed.data;
}
